import React from 'react';
import { ModuleBridge, Tabs, TopActionBar } from '../components';

export const SourceDiscovery = () => {
    const tabItems = [
        {
            key: '1',
            label: 'Preflight Information',
        },
        {
            key: '2',
            label: 'Inventory Information',
        },
    ];

    const handleTabChange = (key) => {
        switch (key) {
            case '1':
                window.handleSourceDiscoveryViewTabs('1');
                break;
            case '2':
                window.handleSourceDiscoveryViewTabs('2');
                break;
            default:
                window.handleSourceDiscoveryViewTabs('1');
                break;
        }
    };

    return (
        <>
            <TopActionBar>
                <Tabs defaultActiveKey="1" items={tabItems} onChange={handleTabChange} />
            </TopActionBar>
            <div id="source_discovery_container"></div>
            <ModuleBridge moduleId="source_discovery_module" />
        </>
    );
};
